// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { SupplierCategoryMap } from './supplier-category-map';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SupplierCategory extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String(250) */
  description!: string;
  /** String(60) */
  name!: string;
  /** Binary */
  rowVersion!: any;
  /** Inv FK supplierCategoryId */
  supplierCategoryMaps!: SupplierCategoryMap[];
}

